import addTour from './addTour';
import editTour from './editTour';
import addDayType from './addDayType';
import editDayType from './editDayType';
import addAssignment from './addAssignment';
import deleteAssignment from './deleteAssignment';
import editAssignment from './editAssignment';


const generateNewOptimisticItem = async (operation, itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId) => {
  let newItem;
  if (operation === 'addTour') {
    newItem = addTour(itemDetails, dayTypesAllowTour);
  }
  if (operation === 'editTour') {
    newItem = editTour(itemDetails, optimisticLiveSchedule, dayTypesAllowTour, resourceId);
  }
  if (operation === 'addDayType') {
    newItem = addDayType(itemDetails, dayTypesAll);
  }
  if (operation === 'editDayType') {
    newItem = editDayType(itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId);
  }
  if (operation === 'addAssignment') {
    newItem = addAssignment(itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId);
  }
  if (operation === 'deleteAssignment') {
    newItem = deleteAssignment(itemDetails, optimisticLiveSchedule, dayTypesAllowTour, resourceId);
  }
  if (operation === 'editAssignment') {
    newItem = editAssignment(itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId);
  }

  return newItem;
}

export default generateNewOptimisticItem;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/generateNewOptimisticItems/index.js